import React from 'react';
import { Text, TextStyle } from 'react-native';

interface HighlightedTextProps {
  str: string;
  separator: string;
  normalTxtStyle?: TextStyle;
  highlightedTxtStyle?: TextStyle;
}

const HighlightedText = ({
  str,
  separator,
  normalTxtStyle,
  highlightedTxtStyle,
}: HighlightedTextProps) => {
  if (!str) return null;

  const parts = str.split(separator);

  return (
    <>
      {parts.map((part, index) => {
        // Odd indices are highlighted (text between separators)
        const isHighlighted = index % 2 === 1;
        return (
          <Text
            key={index}
            style={isHighlighted ? highlightedTxtStyle : normalTxtStyle}
          >
            {part}
          </Text>
        );
      })}
    </>
  );
};

export default HighlightedText;
